import { apiClient } from '@/shared/api/http/client';
import type { AppNotification } from '../model/types';

const base = '/api/notifications';
const quiet = { octo: { expectSuccess: false } } as const;

export const notificationsApi = {
  list: (before?: string, take = 30, unreadOnly = false) =>
    apiClient.get<{ items: AppNotification[]; unread: number; hasMore: boolean }>(base, { params: { before, take, unreadOnly }, ...quiet }),
  unreadCount: () => apiClient.get<{ count: number }>(`${base}/unread-count`, quiet),
  read: (id: string) => apiClient.post(`${base}/${id}/read`, undefined, quiet),
  readAll: () => apiClient.post<{ count: number }>(`${base}/read-all`, undefined, quiet),
  remove: (id: string) => apiClient.delete(`${base}/${id}`, quiet),
};
